module.exports = __webpack_public_path__ + "img/humidity.9d581dc6.png";